import React, { FC } from 'react';
import { Icon } from '@/components/atoms/Icon';
import { Typographies, Typography } from '@/components/atoms/Typography';
import clsx from 'clsx';
import styles from './ValidationItem.module.scss';
import { IconName } from '@/components/atoms/Icon/iconMap';

type ValidationItemType = 'default' | 'success' | 'error';

const iconNames: Record<ValidationItemType, IconName> = {
  default: 'general/bullet/16',
  success: 'general/check/16',
  error: 'general/alert-circle/16',
};

type Props = {
  text: string;
  type?: ValidationItemType;
};

const ValidationItem: FC<Props> = ({ text, type = 'default' }) => {
  return (
    <div className={clsx(styles.item, styles[type])}>
      <Icon name={iconNames[type]} size={16} />
      <Typography variant={Typographies.CAPTION_REGULAR}>{text}</Typography>
    </div>
  );
};

export { ValidationItem };
